import zappy from "@zappy-ride/library.react.components";
import { OutputVehicles } from "./Vehicles";

export * from "./Vehicles";

zappy.FactoryInstance.registerComponent(OutputVehicles);
